// extracted by css-extract-rspack-plugin
export default {"container":"container-clgDIY","logo":"logo-tQv6np"};